import { createFileRoute } from '@tanstack/react-router';
import { ProofPage } from '@/components/proof/ProofPage';

export const Route = createFileRoute('/proof/$proofToken')({
  component: ProofRouteComponent,
});

function ProofRouteComponent() {
  const { proofToken } = Route.useParams();
  return <ProofPage token={proofToken} />;
}
